<div class="row">
  <div class='col-md-8'>
    <app-label label='Wniosek składany do:'>{{ applicationSubmittedTo }}</app-label>
  </div>
</div>
<div class='row'>
  @switch (true) {
    @case (!!application()?.applicationSubject) {
      <div class='col-md-6'>
        <app-label [label]='application() | applicationSubjectLabel'>
          {{ application()?.applicationSubject || '-' }}
        </app-label>
      </div>
    }
    @case ((application()?.service?.roadOccupationPurposes?.length || 0) === 1) {
      <div class='col-md-6'>
        <app-label label='Cel zajęcia:'>
          {{ application()?.service?.roadOccupationPurposes?.at(0)?.name || '-' }}
        </app-label>
      </div>
    }
    @case ((application()?.service?.roadOccupationPurposes?.length || 0) > 1) {
      <div class='col-md-6'>
        <app-label label='Cel zajęcia:'>
          {{ application()?.roadOccupationPurpose?.name || '-' }}
        </app-label>
      </div>
    }
  }
  @if (application()?.transitPeriod; as transitPeriod) {
    <div class="col-md-4">
      <app-label label="Okres przejazdu:">
        {{ transitPeriod || '-' }}
      </app-label>
    </div>
  }
  @if (application()?.exitClass; as exitClass) {
    <div class="col-md-4">
      <app-label label="Klasa zjazdu:">
        {{ exitClass }}
      </app-label>
    </div>
  }
  @if (application()?.deviceType; as deviceType) {
    <div class="col-md-4">
      <app-label label="Rodzaj urządzenia:">
        {{ deviceType }}
      </app-label>
    </div>
  }
  @if (application()?.deviceName; as deviceName) {
    <div class="col-md-4">
      <app-label label="Nazwa">
        {{ deviceName }}
      </app-label>
    </div>
  }
  <div class='col-md-5'>
    <app-label label='Sposób odbioru:'>
      {{ application()?.documentReceiptMethod?.name || '-' }}
    </app-label>
  </div>
  @if (application()?.objectName; as objectName) {
    <div class="col-md-4">
      <app-label label=" Wskazanie obiektu:">
        {{ objectName }}
      </app-label>
    </div>
  }
  @if (showRoadTrafficImpact()) {
    <div class="col-12">
      <app-label
        label="Czy zajęcie pasa wpłynie na ruch drogowy, ograniczy widoczność na drodze lub wprowadzi zmiany <br> w istniejącej organizacji ruchu pojazdów/pieszych?:">
        {{ application()?.roadTrafficImpact || '-' }}
      </app-label>
    </div>
  }
  @if (application()?.applicationConcernsStreet; as applicationConcernsStreet) {
    <div class="col-md-4">
      <app-label label="Wniosek dotyczy ulicy:">
        {{ applicationConcernsStreet }}
      </app-label>
    </div>
  }
  @if (application()?.ePuapAddress) {
    <div class='col-md-6'>
      <app-label label='Adres skrzynki E-puap:'>
        {{ application()?.ePuapAddress || '-' }}
      </app-label>
    </div>
  }
  @if (application()?.eDeliveryAddress) {
    <div class='col-md-6'>
      <app-label label='Adres skrzynki E-doręczeń:'>
        {{ application()?.eDeliveryAddress || '-' }}
      </app-label>
    </div>
  }
  @if (application()?.deviceTypeDescription; as deviceTypeDescription) {
    <div class="col-12">
      <app-label label="Opis rodzaju urządzenia:">
        {{ deviceTypeDescription }}
      </app-label>
    </div>
  }
  @if (application()?.notes; as notes) {
    <div class="col-12">
      <app-label label="Uzasadnienie umieszczenia:">
        {{ notes }}
      </app-label>
    </div>
  }
  @if (application()?.legalInterest; as interest) {
    <div class="col-12">
      <app-label label="Interes prawny:">
        {{ interest }}
      </app-label>
    </div>
  }
</div>
<div class="row">
  @if (agreementDateAndNumber) {
    <div class="col-md-5">
      <app-label label="Nr decyzji/uzgodnienia:">
        {{ application()?.agreementNumber || '-' }}
      </app-label>
    </div>
    <div class="col-md-5">
      <app-label label="Nr decyzji/uzgodnienia:">
        {{ application()?.agreementDate ? (application()?.agreementDate | date) : '-' }}
      </app-label>
    </div>
  }
</div>
@if (showResponsiblePerson()) {
  <br>
  <p class="mb-2">Osoba odpowiedzialna</p>
  <div class="row">
    <div class='col-md-4'>
      <app-label label='Imię:'>
        {{ application()?.responsiblePersonFirstName || '-' }}
      </app-label>
    </div>
    <div class='col-md-4'>
      <app-label label='Nazwisko:'>
        {{ application()?.responsiblePersonLastName || '-' }}
      </app-label>
    </div>
    <div class='col-md-4'>
      <app-label label='Nr telefonu:'>
        {{ application()?.responsiblePersonPhone || '-' }}
      </app-label>
    </div>
    <div class='col-md-4'>
      <app-label label='E-mail:'>
        {{ application()?.responsiblePersonEmail || '-' }}
      </app-label>
    </div>
  </div>
}
@if (showManager()) {
  <br>
  <p class="mb-2">
    <strong>
      Kierownik robót
    </strong>
  </p>
  <div class="row">
    <div class='col-md-4'>
      <app-label label='Imię:'>
        {{ application()?.managerFirstName || '-' }}
      </app-label>
    </div>
    <div class='col-md-4'>
      <app-label label='Nazwisko:'>
        {{ application()?.managerLastName || '-' }}
      </app-label>
    </div>
    <div class='col-md-4'>
      <app-label label='Nr telefonu:'>
        {{ application()?.managerPhone || '-' }}
      </app-label>
    </div>
    <div class='col-md-4'>
      <app-label label='E-mail:'>
        {{ application()?.managerEmail || '-' }}
      </app-label>
    </div>
    <div class='col-md-4'>
      <app-label label='Kod pocztowy:'>
        {{ application()?.managerPostalCode || '-' }}
      </app-label>
    </div>
    <div class='col-md-4'>
      <app-label label='Poczta:'>
        {{ application()?.managerPostOffice || '-' }}
      </app-label>
    </div>
    <div class='col-md-4'>
      <app-label label='Miejscowość:'>
        {{ application()?.managerCity || '-' }}
      </app-label>
    </div>
    <div class='col-md-4'>
      <app-label label='Ulica:'>
        {{ application()?.managerStreet || '-' }}
      </app-label>
    </div>
    <div class='col-md-4'>
      <app-label label='Nr domu:'>
        {{ application()?.managerBuildingNumber || '-' }}
      </app-label>
      @if (application()?.managerHouseNumber; as managerHouseNumber) {
        &nbsp;
        <app-label label='Nr mieszkania:'>
          {{ managerHouseNumber }}
        </app-label>
      }
    </div>
  </div>
}
@if (showCorrespondenceData()) {
  <br>
  <p class="mb-2">Dane osoby wyznaczonej przez wnioskodawcę do kontaktu</p>
  <div class="row">
    <div class="col-md-4">
      <app-label label="Imię/Imiona:">
        {{ application()?.correspondenceFirstName || '-' }}
      </app-label>
    </div>
    <div class="col-md-4">
      <app-label label="Imię/Imiona:">
        {{ application()?.correspondenceLastName || '-' }}
      </app-label>
    </div>
    <div class="col-md-4">
      <app-label label="Imię/Imiona:">
        {{ application()?.correspondencePhone || '-' }}
      </app-label>
    </div>
  </div>
}
